"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.branch.list': '分支',
    'route.branch.create': '添加分支',
    'route.branch.edit': '编辑分支',
};
